import React, { FC, memo, useRef, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import ReactPlayer from 'react-player'

import { InnerContainer } from 'containers/InnerContainer'
import { ButtonMUI } from 'components/ButtonMUI'
import { TitleSection } from 'components/TitleSection'
import { AccessAlphaModal } from './AccessAlphaModal'

import { staticMultimedia } from 'utils'

import styles from './styles.module.scss'


interface IProps {
}


const VideoSection: FC<IProps> = props => {
  const [openAccessAlphaModal, setOpenAccessAlphaModal] = useState(false)
  const [isReadyToPlay, setIsReadyToPlay] = useState(false)
  const playerRef = useRef<any>(null)

  const onReady = React.useCallback(() => {
    setTimeout(() => {
      setIsReadyToPlay(true)
    }, 500)
  }, [playerRef.current])

  const openAccessModal = () => {
    setOpenAccessAlphaModal(true)
  }

  const closeAccessModal = () => {
    setOpenAccessAlphaModal(false)
  }

  return (
    <section className={styles.section}>
      <div className={styles.playerWrapper}>
        <div className={styles.mask}/>
        <div className={cn({
          [styles.opacityWrapper]: true,
          [styles.opacityWrapperOnReady]: isReadyToPlay
        })}>
          <ReactPlayer
            ref={playerRef}
            url={staticMultimedia.somniumSpacePreviewTrailer}
            className={styles.reactPlayer}
            volume={0}
            playing
            loop
            muted
            playsinline
            width="100%"
            height="100%"
            onReady={onReady}
          />
        </div>
      </div>
      <div className={styles.sectionInner}>
        <InnerContainer>
          <div className={styles.container}>
            <TitleSection title={'Somnium Space'}
                          subTitle={'Immersive Metaverse Reimagined'}/>

            <div className={styles.bottomBlock}>
              <div className={styles.leftBox}>
                <div className={styles.bottomTitle}>Discover Somnium Space V3.0:</div>
                <div className={styles.bottomSubtitle}>A limitless metaverse where creativity knows no bounds. Join now
                  and shape your immersive journey.
                </div>
              </div>
              <div className={styles.rightBox}>
                <div className={styles.btnBoxFirst}>
                  <a href={'#welcomeToSomniumSpace'}>
                    <ButtonMUI styleType={'white'}
                               type="button"
                               sx={{
                                 '&&': {
                                   height: '60px',
                                   borderRadius: '30px'
                                 }
                               }}>Learn More</ButtonMUI>
                  </a>
                </div>
                <div className={styles.btnBoxSecond}>
                  <ButtonMUI styleType={'green_2'}
                             onClick={openAccessModal}
                             type="button"
                             sx={{
                               '&&': {
                                 height: '60px',
                                 borderRadius: '30px'
                               }
                             }}>Request to Join 3.0 Alpha</ButtonMUI>
                </div>
              </div>
            </div>
          </div>
        </InnerContainer>
      </div>
      <AccessAlphaModal open={openAccessAlphaModal} onClose={closeAccessModal}/>
    </section>
  )
}

export default memo(VideoSection)
